export interface IServerResponse<T = any> {
  data?: T;
  error: any;
  message: string;
  statusCode: number;
}

export class ServerResponse<T = any> {
  data?: T;
  error: any;
  message: string;
  statusCode: number;

  constructor(data: IServerResponse) {
     this.data = data.data;
     this.error = data.error;
     this.message = data.message;
     this.statusCode = data.statusCode;
  }
}

/* Mensaje en español para un fallo HTTP que NO trae el sobre de la API
   (500 sin manejar, CORS, red caída, 502 con HTML). El status se agrega al
   final de forma discreta; nunca regresa vacío ni "undefined". */
function httpErrorMessage(status: number): string {

  if (status >= 500) {
    return `El servidor no pudo procesar la solicitud. Inténtalo de nuevo en unos minutos. (Código ${status})`;
  }

  if (status === 401 || status === 403) {
    return `No tienes permiso para realizar esta acción. (Código ${status})`;
  }

  if (status === 404) {
    return `No se encontró lo que se solicitó. (Código ${status})`;
  }

  if (status >= 400) {
    return `No se pudo completar la solicitud. Inténtalo de nuevo. (Código ${status})`;
  }

  return 'No se pudo conectar con el servidor. Revisa tu conexión e inténtalo de nuevo.';

}

/* Convierte el error de HttpClient en un ServerResponse. Si la API respondió
   con su sobre {statusCode, message, error, data} se respeta tal cual; si no
   (error.error es un string, un ProgressEvent o no tiene message) se arma uno
   con un mensaje en español según el status HTTP (0 = sin conexión/CORS). */
export function serverResponseFromError(error: unknown): ServerResponse {

  const httpError = error as {
    status?: unknown;
    error?: { statusCode?: unknown; message?: unknown; error?: unknown; data?: unknown } | null;
  } | null;

  const envelope = httpError?.error;

  if (
    envelope
    && typeof envelope === 'object'
    && typeof envelope.statusCode === 'number'
    && typeof envelope.message === 'string'
    && envelope.message.trim() !== ''
  ) {
    return new ServerResponse(envelope as IServerResponse);
  }

  const status = typeof httpError?.status === 'number'
    ? httpError.status
    : 0;

  return new ServerResponse(
    {
      data: undefined,
      error: status > 0 ? `HTTP ${status}` : 'NETWORK',
      message: httpErrorMessage(status),
      statusCode: status
    }
  );

}
